module.exports = __webpack_public_path__ + "img/paid-trans.e1742ee8.svg";